/** @format */
import {
    Button,
    ButtonVariant,
} from '@mpb-com/feather/components/atoms/button';
import { useTranslation } from 'next-i18next';
import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import { WrappedLink } from '@toucan/client/global/nextjs';

import { LinkVariant } from '@toucan/client/shared/components/link';

import { ArticleCarouselProps } from '../article-carousel/types';
import { ArticleTile } from '../article-tile';
import {
    ArticleTileProps,
    ArticleTileSkeletonProps,
} from '../article-tile/types';
import { styles } from './blurred-article-tile.style';

type BlurredArticleTileProps = (ArticleTileProps | ArticleTileSkeletonProps) &
    Required<Pick<ArticleCarouselProps, 'seeAllLink'>>;

const StyledBlurredArticleTile = styled.div`
    ${styles}
`;

export const BlurredArticleTile: FunctionComponent<BlurredArticleTileProps> = ({
    seeAllLink,
    ...props
}) => {
    const { t } = useTranslation();

    return (
        <StyledBlurredArticleTile>
            <ArticleTile {...props}></ArticleTile>
            <WrappedLink
                className="see-all"
                variant={LinkVariant.CUSTOM}
                href={seeAllLink.templatePath}
                as={seeAllLink.href}
            >
                <Button variant={ButtonVariant.TERTIARY}>
                    {t('See all stories')}
                </Button>
            </WrappedLink>
        </StyledBlurredArticleTile>
    );
};
